import {
  ClipboardDocumentCheckIcon,
  ShoppingCartIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  CheckCircleIcon,
  ClockIcon,
  RectangleGroupIcon,
  CubeIcon,
  NewspaperIcon,
  CalendarIcon,
} from "@heroicons/react/24/outline";
import { link } from "d3";
import i18n from "i18next";

export function getProviderMenus() {
  return [
    {
      label: i18n.t("menu.overview"),
      icon: ChartBarIcon,
      link: "/provider-dashboard",
    },
    {
      label: i18n.t("menu.inventory"),
      icon: CubeIcon,
      link: "/inventaire",
    },
    {
      label: i18n.t("Transporteurs"),
      icon: CubeIcon,
      link: "/fournisseur-gestion-expedition",
    },
    {
      label: i18n.t("menu.news"),
      icon: NewspaperIcon,
      link: "/provider-news",
    },

    {
      label: i18n.t("menu.productsAndServices"),
      icon: ClipboardDocumentCheckIcon,
      subMenus: [
        {
          label: i18n.t("menu.products"),
          link: "/provider-dashboard-product-list",
          icon: ShoppingCartIcon,
        },
        {
          label: i18n.t("menu.services"),
          link: "/provider-dashboard-service-list",
          icon: RectangleGroupIcon,
        },
      ],
    },

    /* 🔥 NOUVELLE SECTION COMMANDES */
    {
      label: i18n.t("menu.orders"),
      icon: ClipboardDocumentCheckIcon,
      link: "/orders/products",
    },
  ];
}
